import { theme } from '@chakra-ui/react';

const colorSet = {
    white: '#FFFFFF',
    green: {
        500: '#398E40',
    },
    red: {
        500: '#D12100',
    },
    // primaryColor: '#398E40',
    whiteAlpha: {
        999: '#EFEFEF',
        950: '#EEEEEE',
        900: '#F8F8F8',
        800: '#F2F2F2',
        700: '#DBDBDB',
        600: '#D3D3D3',
        500: '#848484',
        400: '#6E6E6E',
        300: '#4B4B4B',
        200: '#323232',
        100: '#1E1E1E',
        50: '#141414',
        10: '#121212',
    },
};
const charts = [
    '#0050A0',
    '#7DBDF5',
    '#602D84',
    '#9462BA',
    '#DC8C32',
    '#FAD583',
    '#22585A',
    '#4AADAC',
    '#8D92E9',
    '#B5B9FC',
];
const colors = {
    ...theme.colors,
    ...colorSet,
    light: {
        ...colorSet,
        charts,
        brand: {
            '999': '#EFEFEF',
            '950': '#EEEEEE',
            '900': '#F8F8F8',
            '800': '#F2F2F2',
            '700': '#DBDBDB',
            '600': '#D3D3D3',
            '500': '#848484',
            '400': '#6E6E6E',
            '300': '#4B4B4B',
            '200': '#323232',
            '100': '#1E1E1E',
            '50': '#141414',
            '10': '#121212',
        },
        primaryColor: '#398E40',
        navbarBg: '#FFFFFF',
        navbarTextColor: '#121212',
        navbarIconBg: '#E6E6E6',
        menuBg: '#111620',
        menuActiveTextColor: '#FFFFFF',
        menuTextColor: '#576279',
        menuIconColor: '#576279',
        pageBg: '#F8F8F8',
        componentBg: '#FFFFFF',
        componentBorder: '#EEEEEE',
        inputText: '#323232',
        contentText: '#323232',
        tooltipBg: '#4B4B4B',
        tooltipTextColor: '#FFFFFF',
        boxShadow: '#00000029',
        calendarSelectedSpan: '#CFE9BE',
        errorText: '#D12100',
        tableRowBorder: '#E2E2E2',
        subTableRowBorder: '#CECECE',
        tagBg: '#EFEFEF',
        // selectedTag: '#15651C',
        tableResizerBg: '#e3e3e3',
        tableResizingActiveBg: '#6E6E6E',
        tableDragOverBg: '#e5efff',
    },
    dark: {
        ...colorSet,
        charts,
        brand: {
            '10': '#EFEFEF',
            '50': '#EEEEEE',
            '100': '#F8F8F8',
            '200': '#F2F2F2',
            '300': '#DBDBDB',
            '400': '#D3D3D3',
            '500': '#848484',
            '600': '#6E6E6E',
            '700': '#4B4B4B',
            '800': '#323232',
            '900': '#1E1E1E',
            '950': '#141414',
            '999': '#121212',
        },
        primaryColor: '#398E40',
        navbarBg: '#1E1E1E',
        navbarTextColor: '#EFEFEF',
        navbarIconBg: '#141414',
        menuBg: '#1E1E1E',
        menuActiveTextColor: '#FFFFFF',
        menuTextColor: '#6E6E6E',
        menuIconColor: '#6E6E6E',
        pageBg: '#121212',
        inputText: '#939393',
        contentText: '#6E6E6E',
        componentBg: '#1E1E1E',
        componentBorder: '#323232',
        tooltipBg: '#F8F8F8',
        tooltipTextColor: '#1E1E1E',
        boxShadow: '#00000059',
        calendarSelectedSpan: '#122719',
        errorText: '#ff593a',
        tableRowBorder: '#323232',
        subTableRowBorder: '#323232',
        tagBg: '#323232',
        // selectedTag: '#EEEEEE',
        tableResizerBg: '#424242',
        tableResizingActiveBg: '#4299e199',
        tableDragOverBg: '#1f2223',
    },
};

export default colors;
